module.exports = __webpack_public_path__ + "img/chatGPT.b3070d05.jpg";